module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg7-fb485d60d7b351c883d5b852a2a1a521.jpg";